
















import { Component } from "vue-property-decorator";
import { TextareaAutoresize } from "@share/common/controls/textarea-autoresize/textarea-autoresize"

@Component
export default class CommentTextarea extends TextareaAutoresize {

    highLight(type: "red") {
        if(type === "red") {
            this.flashClass("comment-textarea_highlight-red");
        }
    }

    flashClass(className: string, duration = 1000) {
        if(!this.$el.classList.contains(className)) {
            this.$el.classList.add(className);
            setTimeout(() => {
                this.$el.classList.remove(className);
            }, duration);
        }
    }
}
